import * as reduxUtil from 'redux/utils/reducers';
import * as CONSTS from 'redux/constants';
import { IShortlinkState } from 'consts/shortlink';

const initialState: IShortlinkState = {
  ...reduxUtil.initializeObject(),
  pageType: ''
};

const reducer = (state = initialState, action: { payload: any; type: string }) => {
  const { error } = action?.payload || {};

  switch (action.type) {
    case CONSTS.GET_SHORTLINK_PAGE_START:
      return {
        ...state,
        loading: true
      };
    case CONSTS.GET_SHORTLINK_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      };
    case CONSTS.GET_SHORTLINK_PAGE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        error
      };
    default:
      return state;
  }
};

export default reducer;
